var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircularArc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1385.181,
    height: 662.487,
    viewBox: "0 0 1385.181 662.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 1385.181,
    height: 662.487,
    fill: "#0d0c33"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1654",
    "data-name": "Groupe 1654",
    transform: "translate(1385.181 662.487) rotate(-180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_825",
    "data-name": "Trac\\xE9 825",
    d: "M692.589,662.487c381.833,0,692.587-297.243,692.587-662.487h-164.44c0,278.448-237.034,505.173-528.147,505.173S164.442,278.448,164.442,0H0C0,365.244,310.727,662.487,692.589,662.487",
    transform: "translate(0.002 0)",
    fill: "#0d0c33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularArc);
export default __webpack_public_path__ + "static/media/circular_arc.f7728eae3e04d3e9efe8b6cb43c7f5ef.svg";
export { ForwardRef as ReactComponent };